//---------------------------------
// create new character item entry
//---------------------------------
export default function createNewCharacterItemEntry({
  id, // temp id used for tracking
  type,
  equipment_type,
  static_item,
  artefact_id, // used to indicate artefact/temp static item id for item objects to be created first in backend then linked to character-item
  artefact_name, // used to indicate artefact name for item objects to be created first in backend then linked to character-item (as static item name not used for artefacts created via free text entry)
  tally_qty,
  player_notes,
  notes,
  value_lower = 0,
  value_upper = 0,
  estimated_value = false,
  worn_location = null,
  attach_location = null,
  armour_location = null, // where armour fixed = false i.e. need to select from available armour locations
  container = null,
  runes = [],
  non_rune_spells = [],
  starter = false,
  active = false,
  campaign = false,
  tallyable = false,
  countable = false,
  wearable = false,
  storeable = false,
  held = false,
  storage = false,
  attachable = false,
  attach_point = false,
  worn = false,
  broken = false,
  character = null,
  display_name = null,
  short_description = '',
  container_size = null,
  container_capacity = '',
  container_size_short = '',
  container_size_long = '',
  contents_count_direct = null,
  contents_count_total = null,
  ap = null,
  hp = null,
  coverage = null,
  dex_pen = null,
  layer = null,
  coverage_locations = [],
  equipped = false,
  skills = [],
  enc = 0,
  tot_enc = 0,
  damage_dice = null,
  impale = null,
  set_charge = null,
  load = null,
  range = null,
  max_unit_count = null,
  cur_unit_count = null,
  unit_name = null,
  healing_type = null,
  recovers = null,
  poison_type = null,
  pot = null,
  effect = null,
  delay = null,
  duration = null,
  resist = null,
  pwr_storage = 0,

  artefact_type = '',
  artefact_base_item = null,
  trait = null,
  material = '',
  quality = '',
  age = '',
  currency = null,
  race = null,
  description = '',
  image = null,
  item_traits = [],
  image_file = null,
  create_static_item = false,
  _static_material_unknown = undefined,
  _static_quality_unknown = undefined,
  _static_age_unknown = undefined,
  _static_race_unknown = undefined,
  _static_currency_unknown = undefined,
  _static_value_unknown = undefined,
  _static_value_lower_unknown = undefined,
  _static_value_upper_unknown = undefined,
  _static_estimated_value_readonly = undefined,
  _static_enc_readonly = undefined,
  _static_countable_readonly = undefined,
  _static_unit_name_readonly = undefined,
  _static_max_unit_count_readonly = undefined,
} = {}) {
  console.log('-----------------------')
  console.log('IN createNewCharacterItemEntry')

  let character_id = null
  if (character && typeof character === 'object') {
    character_id = character.id
  }
  //------------------------------------------------------------------------------------------------------
  // item id: use static item id - or use temp id from itemcard for artefacts (item object to be created)
  //------------------------------------------------------------------------------------------------------
  const item_id = static_item?.id ? static_item?.id : artefact_id ? artefact_id : null
  //------------------
  // define structure
  //------------------
  let item = {
    item: item_id,
    // only include character id for new item
    ...(character ? { character: character_id } : {}),

    // from static item
    name: static_item?.name ?? artefact_name ?? '', // for artefacts use payload name (from itemcard) as static item name not used for artefacts created via free text entry
    //
    display_name: display_name,

    // improvements (from itemCard)
    id: id, // temp id used for tracking
    type: type,
    equipment_type: equipment_type,
    tally_qty: tally_qty,
    player_notes: player_notes ?? notes ?? '',
    value_lower: value_lower,
    value_upper: value_upper,
    estimated_value: estimated_value,
    worn_location: worn_location,
    attach_location: attach_location,
    armour_location: armour_location,
    container: container,
    runes: runes,
    non_rune_spells: non_rune_spells,
    starter: starter,
    active: active,
    campaign: campaign,
    tallyable: tallyable,
    countable: countable,
    wearable: wearable,
    storeable: storeable,
    held: held,
    storage: storage,
    attachable: attachable,
    attach_point: attach_point,
    worn: worn,
    broken: broken,
    short_description: short_description,
    enc: enc,
    tot_enc: tot_enc,
    contents_enc: 0, // will be zero initially
    container_size: container_size,
    container_capacity: container_capacity,
    container_size_short: container_size_short,
    container_size_long: container_size_long,
    contents_count_total: contents_count_total,
    contents_count_direct: contents_count_direct,
    ap: ap,
    hp: hp,
    coverage: coverage,
    dex_pen: dex_pen,
    layer: layer,
    coverage_locations: coverage_locations,
    equipped: equipped,
    skills: skills,
    damage_dice: damage_dice,
    impale: impale,
    set_charge: set_charge,
    load: load,
    range: range,
    max_unit_count: max_unit_count,
    cur_unit_count: cur_unit_count,
    unit_name: unit_name,
    healing_type: healing_type,
    recovers: recovers,
    poison_type: poison_type,
    pot: pot,
    effect: effect,
    delay: delay,
    duration: duration,
    resist: resist,
    pwr_storage: pwr_storage,
    artefact_type: artefact_type,
    artefact_base_item: artefact_base_item,
    trait: trait,
    material: material,
    quality: quality,
    age: age,
    currency: currency,
    race: race,
    description: description,
    image: image,
    item_traits: Array.isArray(item_traits)
      ? [...item_traits]
      : Array.isArray(static_item?.item_traits)
        ? [...static_item.item_traits]
        : [],
    image_file: image_file,
    create_static_item: create_static_item,
    _static_material_unknown: _static_material_unknown,
    _static_quality_unknown: _static_quality_unknown,
    _static_age_unknown: _static_age_unknown,
    _static_race_unknown: _static_race_unknown,
    _static_currency_unknown: _static_currency_unknown,
    _static_value_unknown: _static_value_unknown,
    _static_value_lower_unknown: _static_value_lower_unknown,
    _static_value_upper_unknown: _static_value_upper_unknown,
    _static_estimated_value_readonly: _static_estimated_value_readonly,
    _static_enc_readonly: _static_enc_readonly,
    _static_countable_readonly: _static_countable_readonly,
    _static_unit_name_readonly: _static_unit_name_readonly,
    _static_max_unit_count_readonly: _static_max_unit_count_readonly,
  }
  return item
}
